import { alpha } from '@mui/material/styles';
import { colors } from './colors';

/**
 * Bordes de input unificados (verde teal de marca).
 * Idle / hover / focus: siempre en la familia verde — sin gris ni negro.
 * Focus: solo un poco más oscuro que `success.main` (#0CBB9A), no el dark de palette.
 */
export const focusTokens = {
  /** Idle: verde suave (sin gris) */
  idleBorderColor: alpha(colors.success.main, 0.45),
  /** Hover: verde de marca */
  hoverBorderColor: colors.success.main,
  /** Focus: apenas más oscuro que el main */
  borderColor: '#0BB296',
  labelColor: colors.success.main,
  borderWidth: 2,
  idleBorderWidth: 1,
  ring: `0 0 0 3px ${alpha(colors.success.main, 0.2)}`,
  ringSoft: `0 0 0 3px ${alpha(colors.success.main, 0.12)}`,
} as const;
